import React, { useState } from "react";
import ImagemFukyo from "../Imagem-Fukyo/Imagem-Fukyo";
import './Content-Cile-List.scss';
import { withRouter, } from "react-router-dom";
import { Configurations } from "../../Utils/Configurations";
import axios from "axios";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import moment from "moment";



const ContentCileList = (props) => {

    const { conteudo, history, setLoading, chamadaBanners, youtube } = props;
    const [openModalExcluir, setOpenModalExcluir] = useState(false)
    const [itemToDelete, setItemToDelete] = useState(null);

    const toggleModalExcluir = (id) => {
        setOpenModalExcluir(!openModalExcluir)
        if (id) {
            setItemToDelete(id);
        } else {
            setItemToDelete(null);
        }
    }

    const editBanner = (imagem, link, id, initial_date, end_date, type, linkYoutube) => {
        history.push({
            pathname: `banners/detalhes/${id}`,
            state: { imagem, link, id, initial_date, end_date, type, linkYoutube }
        });
    };

    const editResenha = (titulo, resumo, pdf, link, id) => {
        history.push({
            pathname: `resenhas/detalhes/${id}`,
            state: { titulo, resumo, pdf, link, id }
        });
    };

    const editVideo = (titulo, descricao, youtube, vimeo, id, books_id) => {
        history.push({
            pathname: `videos/detalhes/${id}`,
            state: { titulo, descricao, youtube, vimeo, id, books_id }
        });
    };

    const excluirBanner = () => {
        const config = new Configurations();
        setLoading(true);
        axios.post(config.apiBasePath + `/conteudo-cile/banners/excluir/${itemToDelete}`)
            .then(() => {
                toggleModalExcluir();
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() => {
                chamadaBanners();
            });
    }

    const alteraPosicao = (idItem, direcao) => {

        const config = new Configurations();
        axios.put(config.apiBasePath + `/conteudo-cile/banners/muda-posicao/${idItem}/${direcao}`,)
            .then(() => {
                chamadaBanners()
            })
            .catch(err => {
                console.log("ERROR: ", err)
            })
            .finally(chamadaBanners())
    }

    return (
        <div className="lista-conteudo">
            {(conteudo.videos ? conteudo.videos : conteudo.resenhas ? conteudo.resenhas : youtube ? conteudo[0] : conteudo).map((item, index) => {
                return (
                    <div className="col-lg-10 col-12 pt-2 mt-3 offset-lg-1 offset-0 content-product " key={index} >
                        <div className="card bg-white">
                            <div className={`${youtube ? 'bg-primary' : 'bg-purple'} text-white card-header`}>
                                <div className="row no-gutters">
                                    <div className="col-12 pb-3 pb-lg-0">
                                        <div className="row no-gutters">
                                            <div className="col-3 border-white">
                                                <span className="tipo-label d-flex align-items-center">
                                                    {conteudo.videos ? 'Vídeos' : conteudo.resenhas ? 'Resenhas' : youtube ? 'YouTube' : 'Carrossel'}
                                                </span>

                                            </div>
                                            <React.Fragment>
                                                <div className="col-4 d-none d-md-block text-left">
                                                    {conteudo ?
                                                        <span className={`badge ${item.statusPublicacao === 'Agendado' ? 'badge-warning text-dark' : 'badge-success'}`}>{item.statusPublicacao}</span>
                                                        :
                                                        <span className={`badge badge-success`}>CILE</span>}
                                                </div>
                                                <div className="col-9 col-md-5 text-right border-white d-flex justify-content-end align-items-center">
                                                    {conteudo &&
                                                        <>
                                                            {
                                                                conteudo.videos ?
                                                                    <button className="btn btn-outline-light" type="button" onClick={() => editVideo(item.title, item.description, item.link_youtube, item.video, item.id, item.books_id)} >
                                                                        Editar Vídeo
                                                                    </button>
                                                                    :
                                                                    conteudo.resenhas ?
                                                                        <button className="btn btn-outline-light" type="button" onClick={() => editResenha(item.title, item.resume, item.pdf, item.external_link, item.id)} >
                                                                            Editar Resenha
                                                                        </button>
                                                                        :
                                                                        <>
                                                                            {!youtube &&
                                                                                <>
                                                                                    <i className={'cursor-pointer fas fa-arrow-up icones-destaques-ativos px-3 ' + (index === 0 ? 'd-none' : null)} onClick={() => alteraPosicao(item.id, 'cima')} ></i>
                                                                                    <i className={'cursor-pointer fas fa-arrow-down icones-destaques-ativos px-3 ' + (index === (conteudo.length - 1) ? 'd-none' : null)} onClick={() => alteraPosicao(item.id, 'baixo')} ></i>
                                                                                </>
                                                                            }
                                                                            <button className="btn btn-outline-light" type="button" onClick={() => editBanner(item.image, item.url, item.id, item.initial_date, item.end_date, item.type, item.linkYoutube)} >
                                                                                Editar banner
                                                                            </button>
                                                                        </>
                                                            }
                                                            {!youtube ?
                                                                <i onClick={() => toggleModalExcluir(item.id)} className={`ml-4 far fa-trash-alt text-light icone-remover cursor-pointer`}></i>
                                                                : conteudo[0].length > 1 ?
                                                                    <i onClick={() => toggleModalExcluir(item.id)} className={`ml-4 far fa-trash-alt text-light icone-remover cursor-pointer`}></i>
                                                                    : null
                                                            }
                                                        </>
                                                    }

                                                </div>
                                            </React.Fragment>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={`card-body pt-3`}>
                                <div className="card-body pt-3">
                                    <div className="row no-gutters">
                                        <div className="col-3 d-lg-block d-none">
                                            <ImagemFukyo
                                                className={`img img-fluid`}
                                                src={conteudo.videos || conteudo.resenhas ? item.image : `https://api.ciledigital.com.br/file/banner/${item.image}`}
                                                alt={`imagem-destaque`}
                                            />

                                        </div>
                                        <div className="col-lg-9 col-12  px-lg-4 px-0" >
                                            <div className="row">
                                                <div className="col-12">
                                                    {conteudo.videos ?
                                                        <>
                                                            <p className="infos-ativos"><strong>Título:</strong> {item.title}</p>
                                                            <p className="infos-ativos"><strong>Link Vimeo:</strong> <a href={item.video} target="_blank" rel="noopener noreferrer">{item.video}</a> </p>
                                                            <p className="infos-ativos"><strong>Link Youtube:</strong> <a href={item.link_youtube} target="_blank" rel="noopener noreferrer">{item.link_youtube}</a> </p>
                                                            <p className="infos-ativos "><strong>Descrição:</strong> {item.description} </p>
                                                        </>
                                                        :
                                                        conteudo.resenhas ?

                                                            <>
                                                                <p className="infos-ativos"><strong>Título:</strong> {item.title}</p>
                                                                <p className="infos-ativos"><strong>Resumo:</strong> {item.resume}</p>

                                                                {item.pdf ? <p className="infos-ativos"><strong>PDF:</strong> <a href={`https://api.ciledigital.com.br/file/pdf/${item.pdf}`} target="_blank" rel="noopener noreferrer">{item.pdf}</a> </p>
                                                                    : <p className="infos-ativos"><strong>WordPress:</strong> <a href={item.external_link} target="_blank" rel="noopener noreferrer">{item.external_link}</a> </p>}
                                                            </>
                                                            :
                                                            <>
                                                                {youtube ?
                                                                    <p className="infos-ativos"><strong>Link do vídeo:</strong>
                                                                        <a href={item.linkYoutube} target="_blank" rel="noopener noreferrer"> {item.linkYoutube}</a>
                                                                    </p>
                                                                    :
                                                                    <p className="infos-ativos"><strong>Redirecionar para:</strong>
                                                                        <a href={`https://ciledigital.brasilseikyo.com.br${item.url}`} target="_blank" rel="noopener noreferrer">https://ciledigital.brasilseikyo.com.br{item.url}</a>
                                                                    </p>}

                                                                <p className="infos-ativos"><strong>Data inicial:</strong> {moment(item.initial_date).format('DD/MM/YYYY')}</p>
                                                                <p className="infos-ativos"><strong>Data final:</strong> {item.end_date ? moment(item.end_date).format('DD/MM/YYYY') : 'Não definido'}</p>
                                                            </>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}

            <Modal isOpen={openModalExcluir} toggle={toggleModalExcluir}>
                <ModalHeader toggle={toggleModalExcluir}>
                    Excluir banner
                </ModalHeader>
                <ModalBody>
                    <div className='row'>
                        <div className='col-12 pt-2'>
                            <p>Tem certeza que deseja excluir este banner?</p>
                        </div>

                    </div>

                </ModalBody>
                <ModalFooter>
                    <button className='btn btn-sm btn-outline-secondary' onClick={toggleModalExcluir} >
                        Cancelar
                    </button>
                    <button className='btn btn-sm btn-outline-danger' onClick={() => excluirBanner(1)} >
                        Excluir
                    </button>
                </ModalFooter>
            </Modal>
        </div>

    )
}
export default withRouter(ContentCileList);